import React, { memo } from 'react';
import { I_DirectionList } from '@Redux/search/interfaces';
import DirectionList from './DirectionList';
import styles from '../styles.module.scss';
import { useTranslation } from 'react-i18next';

interface I_groupData {
    NormGroupID: string;
    GroupID: string;
    GoDate: string;
    DirectionList: Array<I_DirectionList>;
}

interface I_Props {
    GroupList: I_groupData;
}

const GroupList: React.FC<I_Props> = ({ GroupList }) => {
    const { t } = useTranslation();

    return (
        <ul className={styles.groupList}>
            <li className={styles.group}>
                <div className={styles.basics}>
                    <div className={styles.groupID}>
                        {`${t('ProductID')}`}：{GroupList.GroupID}
                    </div>
                </div>
                {Array.isArray(GroupList.DirectionList) && GroupList.DirectionList.length > 0 && (
                    <div className={styles.flights}>
                        <DirectionList directions={GroupList.DirectionList} />
                    </div>
                )}
            </li>
        </ul>
    );
};

export default memo(GroupList);
